<template>
  <div id="interest-search">
    <!-- <div id="feedback" v-if="false">
      <button @click="openFeedback">Feedback</button>
    </div> -->
    <div id="carousel" class="ds-main ds-border" :class="{'show-majors': selected}" v-if="currentArea">
      <img class="slide-img" :src="currentArea.large_image_url"></img>
      <transition name="fade">
        <div class="arrow" v-if="!selected" @click="previousArea">
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="!selected" class="slide-info">
          <h1>{{currentArea.name}}</h1>
          <p>{{currentArea.definition}}</p>

          <a @click="selected = true">See Majors</a>
        </div>
      </transition>
      <transition name="fade">
        <div class="arrow" v-if="!selected" @click="nextArea">
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </div>
      </transition>

      <div id="carousel-swiper">
        <swiper ref="swiper" :options="swiperOptions" :not-next-tick="notNextTick">
          <!-- slides -->
          <swiper-slide v-for="(area, i) in interestAreas" :key="i">
            <div
              class = 'swiper-content ds-main ds-border'
              :class = "{'current-area': area === currentArea}"
              @click = 'swiperClick(area, i)'
            >
              <!-- eager load but hide the large version so that it is ready for the large carousel -->
              <img class = 'swiper-img' v-show = 'false' :src = 'area.large_image_url'></img>

              <!-- display the medium version -->
              <img class = 'swiper-img' :src = 'area.medium_image_url'></img>
              <div class = 'swiper-title'>
                {{area.name}}
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>

      <transition name="carousel-back">
        <div v-if="selected" class="carousel-back ds-main ds-background" @click="selected = false">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </div>
      </transition>
    </div>

    <transition name="fade">
      <div v-if="selected" id="interest-majors">
        <major-list :majors="currentMajors"></major-list>
      </div>
    </transition>

  </div>
</template>

<script>
  import MajorList from '../components/major_list'

  export default {
    name: 'InterestSearch',

    data() {
      return {
        notNextTick: true,
        autoPlayTimeout: null,
        allInterestAreas: [],
        swiperOptions: {
          slidesPerView: 5,
          mousewheelControl: true,
          // freeMode: true,
          spaceBetween: 20,
          direction: 'horizontal',
          centeredSlides: true,
          initialSlide: 0,
          threshold: 25,
          onSlideChangeStart: swiper => {
            this.goToArea(swiper.realIndex)
          }
        }
      }
    },

    created() {
      this.setSlideCount()

      window.addEventListener('resize', () => {
        this.setSlideCount()
      })
    },

    mounted() {
      this.$http('interest_areas_2.json')
        .then(response => {
          this.allInterestAreas = response.data
          if (!this.currentQuery) this.goToArea(0)
          this.swiperOptions.initialSlide = this.currentIndex
          // console.log(this.$http('interest_areas_2.json'))
        })
        .catch(error => console.log(error))

      window.addEventListener('keyup', this.slide)
      this.resetAutoPlayTimeout()
    },

    beforeDestroy() {
      window.removeEventListener('keyup', this.slide)
      clearTimeout(this.autoPlayTimeout)
    },

    watch: {
      currentArea() {
        this.centerCarousel()
      }
    },

    computed: {

      // only include interest areas that have majors
      interestAreas() {
        return this.allInterestAreas.filter(area => {
          return !!this.majors.find(major => {
            if ('cip_code_id_additional' in area) {
              return major.master_cip_code_id === area.cip_code_id_additional
            } else {
              return major.master_cip_code_id === area.cip_code_id
            }
          })
        })
      },

      // get feedback url
      feedbackUrl() {
        return this.$store.state.university.feedback_url
      },

      // fetch majors from store
      majors() {
        return this.$store.getters.currentMajors
      },

      // majors for current interest area
      currentMajors() {
        if (!this.currentArea) return []
        return this.majors.filter(major => {
          if ('cip_code_id_additional' in this.currentArea && major.master_cip_code_id === this.currentArea.cip_code_id_additional) {
            return major.master_cip_code_id === this.currentArea.cip_code_id_additional
          } else {
            return major.master_cip_code_id === this.currentArea.cip_code_id
          }
        })
      },

      // querystring current interest param
      currentQuery() {
        return this.$route.query.interest
      },

      // index of current interest area
      currentIndex() {
        return this.interestAreas.indexOf(this.currentArea)
      },

      // current interest area
      currentArea() {
        return this.interestAreas.find(a => a.cip_code_id == this.currentQuery)
      },

      // get selected from the query, on set $route to the interest area
      selected: {
        get() {
          return ['true', true].includes(this.$route.query.selected)
        },
        set(selected) {
          this.goToArea(this.currentIndex, selected)
        }
      }
    },

    methods: {
      // $route to interest area, optional selected query param may be set
      goToArea(index, selected = this.selected, method = 'replace') {
        this.swiperOptions.initialSlide = index
        const query = {interest: this.interestAreas[index].cip_code_id}
        if (selected) query.selected = true
        this.$router[method]({
          name: 'interestSearch',
          query: query
        })
        this.resetAutoPlayTimeout()
      },

      openFeedback() {
        window.open(this.feedbackUrl)
      },

      resetAutoPlayTimeout() {
        clearTimeout(this.autoPlayTimeout)
        this.autoPlayTimeout = setTimeout(() => {
          if (!this.selected) this.nextArea()
        }, 10000)
      },

      swiperClick(area, i) {
        if (area === this.currentArea) this.selected = !this.selected
        else this.goToArea(i)
      },

      // $route to next interest area
      nextArea() {
        const count = this.interestAreas.length - 1
        const index = this.currentIndex
        const next = index < count ? index + 1 : 0
        this.goToArea(next)
      },

      // $route to next interest area
      previousArea() {
        const count = this.interestAreas.length - 1
        const index = this.currentIndex
        const prev = index > 0 ? index - 1 : count
        this.goToArea(prev)
      },

      // interest area slide events for left right arrow keys
      slide(e) {
        if (e.keyCode === 37) {
          this.previousArea()
        } else if (e.keyCode === 39) {
          this.nextArea()
        }
      },

      setSlideCount() {
        this.swiperOptions.slidesPerView = Math.max(1.6, Math.round(document.body.clientWidth / 330))
      },

      centerCarousel() {
        if (this && this.$refs.swiper) {
          this.$refs.swiper.swiper.slideTo(this.currentIndex)
        }
      }
    },

    components: {
      MajorList
    }
  }
</script>



// WEBPACK FOOTER //
// InterestSearch.vue?68ddb72d